export const DEFAULT_ADDITIONAL_DOCUMENT_FORMATS =
  '.jpeg,.jpg,.png,.pdf,.docx,.doc,.text,.heic';
